/**
 * Centralized routing configuration for the application.
 * @constant
 *
 * Structure:
 * - `path:` Raw path string for route matching
 * - `getHref:` Function that returns the path, allowing for:
 *   - Dynamic path generation
 *   - Query parameter handling
 *   - Future path modifications without changing route definitions
 *
 * Benefits:
 * - Type-safe route definitions
 * - Single source of truth for paths
 * - Easier path updates and maintenance
 * - Prevents hardcoded strings across the app
 *
 * @example
 * ```
 * path: '/sim-details/:iccid'
 * getHref: (iccid: string) => `/sim-details/${iccid}`
 * ```
 */
export const paths = {
  dashboard: {
    path: '/dashboard',
    getHref: () => '/dashboard',
  },
  simDetail: {
    path: '/detail/:id',
    getHref: (iccid: string) => `/detail/${iccid}`,
  },
  availableSims: {
    path: '/available-sims',
    getHref: () => '/available-sims',
  },
  availableESims: {
    path: '/available-esims',
    getHref: () => '/available-esims',
  },
  fixedNeverBeenActivated: {
    path: '/fixed-never-been-activated',
    getHref: () => '/fixed-never-been-activated',
  },
  sprDashboard: {
    dashboard: { path: '/spr-dashboard', getHref: () => '/spr-dashboard' },
    pendingApprovalOrders: {
      path: '/spr-dashboard/pending-approval',
      getHref: () => '/spr-dashboard/pending-approval',
    },
  },
  acceptInvitation: {
    path: '/accept-invitation/:token',
    getHref: (token: string) => `/accept-invitation/${token}`,
  },
  fixedDashboard: {
    path: '/fixed-dashboard',
    getHref: () => '/fixed-dashboard',
  },
  login: {
    path: '/login',
    getHref: () => '/login',
  },
  twoFactorAuth: {
    path: '/two-factor-auth',
    getHref: () => '/two-factor-auth',
  },
} as const;
